import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import type { PlotRect as PlotRectAction } from "@pdfking/renderer-api"

import { PlotMixin as mixin } from "../mixins/PlotMixin"

export const PlotRect = CreateRenderFunction({
  mixins: [mixin] as const,
  props: {
    action: {} as PlotRectAction,
  },
  render() {
    if (!this.action.stroke_color && !this.action.fill_color) {
      return undefined
    }
    return (
      <rect
        className="pointer-events-none"
        fill={this.get_color(this.action.fill_color)}
        height={this.get_h(this.action.position)}
        stroke={this.get_color(this.action.stroke_color)}
        // its own width, scaling with the page as the print's does
        stroke-width={this.to_px(this.action.stroke_width)}
        transform={this.transform_coords(this.action.position)}
        width={this.get_w(this.action.position)}
      />
    )
  },
})
